export default __webpack_public_path__ + "static/media/section3_bg3.e7349be5.png";